import { render } from "./FormPurchase.vue?vue&type=template&id=376d1dc3"
import script from "./FormPurchase.vue?vue&type=script&lang=js"
export * from "./FormPurchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__